module.exports = __webpack_public_path__ + "static/media/icon-settings.6154bf0b.svg";